var _path, _path2, _path3, _path4, _g, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscount10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17238 47.332C6.67972 48.1827 7.48887 48.8112 8.43871 49.0922L13.0289 50.4503L18.4326 52.0166C19.4816 52.3207 20.6097 52.1758 21.5478 51.6164L46.7963 36.5596C48.6654 35.445 49.277 33.0263 48.1624 31.1573L40.1086 17.6519C38.994 15.7829 36.5753 15.1713 34.7063 16.2859L9.38886 31.3837C8.49132 31.919 7.84317 32.7888 7.58699 33.802L5.16335 43.3867C4.90716 44.3999 5.06394 45.4733 5.59918 46.3708L6.17238 47.332ZM11.3917 43.5154C10.987 42.8368 10.1089 42.6148 9.43026 43.0194C8.75166 43.4241 8.5296 44.3023 8.93428 44.9809C9.33896 45.6595 10.2171 45.8815 10.8957 45.4769C11.5743 45.0722 11.7964 44.194 11.3917 43.5154Z",
    stroke: "#FC916B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1255 29.7371C31.8984 29.2762 32.1673 28.3028 31.7262 27.563C31.285 26.8232 30.3008 26.5971 29.5279 27.058C28.755 27.5189 28.4861 28.4923 28.9272 29.2321C29.3684 29.9719 30.3526 30.198 31.1255 29.7371Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7495 32.8172C39.5224 32.3562 39.7914 31.3829 39.3502 30.6431C38.909 29.9033 37.9248 29.6772 37.1519 30.1381C36.379 30.599 36.1101 31.5724 36.5513 32.3122C36.9924 33.052 37.9766 33.2781 38.7495 32.8172Z",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5939 24.3438L32.4319 35.8003",
    stroke: "#FC916B",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3190_7132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.11328 21.3672C2.11328 21.3672 6.98867 23.1319 8.11566 23.9235",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69141 4.62695C8.78967 6.68333 10.0565 8.64512 11.479 10.4922C12.5015 11.791 15.7674 16.973 15.7674 16.973",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2866 5.16211C26.2866 5.16211 25.3652 10.8106 25.4106 11.0097",
    stroke: "#FC916B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "50 3 100 3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3363 38.0688L18.1927 37.1002L20.7272 41.3501L19.4957 42.0844L19.4098 42.1357L19.461 42.2216L20.1001 43.2931L20.1513 43.379L20.2372 43.3278L23.8943 41.1469L23.9802 41.0956L23.9289 41.0098L23.2899 39.9382L23.2387 39.8523L23.1528 39.9035L22.059 40.5558L18.6219 34.7923L18.5707 34.7065L18.4848 34.7577L18.3472 34.8398L18.3336 34.8478L18.3232 34.8596L16.5531 36.8749L16.505 36.9295L16.5423 36.9921L17.1755 38.0538L17.2456 38.1714L17.3363 38.0688ZM27.754 39.005C28.6627 38.4631 29.254 37.7051 29.4838 36.8562C29.7136 36.007 29.579 35.0764 29.0536 34.1954L28.2504 32.8486C27.7221 31.9628 26.966 31.3995 26.1088 31.1968C25.252 30.9942 24.304 31.1541 23.3952 31.696C22.4864 32.238 21.8951 32.996 21.6661 33.8462C21.437 34.6967 21.5732 35.6297 22.1015 36.5155L22.9046 37.8624C23.43 38.7434 24.1848 39.3041 25.0412 39.5056C25.8973 39.7069 26.8452 39.547 27.754 39.005ZM27.0066 37.7519C26.4754 38.0687 25.9367 38.1525 25.4573 38.0333C24.9779 37.914 24.5471 37.5891 24.2365 37.0681L23.4333 35.7213C23.1226 35.2003 23.0415 34.6668 23.1644 34.1884C23.2874 33.71 23.6172 33.2758 24.1484 32.959C24.6796 32.6422 25.2183 32.5584 25.6977 32.6777C26.1771 32.7969 26.6079 33.1218 26.9186 33.6428L27.7218 34.9896C28.0324 35.5106 28.1136 36.0441 27.9906 36.5225C27.8677 37.001 27.5379 37.4351 27.0066 37.7519Z",
    fill: "#FC916B",
    stroke: "#FC916B",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3190_7132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7919,
    height: 23.5911,
    fill: "white",
    transform: "translate(6.21729) rotate(12.6053)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount10);
export default __webpack_public_path__ + "static/media/discount-10.dcc5630d8524284a3fe583ff48278b1c.svg";
export { ForwardRef as ReactComponent };